import React from 'react'
import { Link } from 'gatsby'
import matrixIcon from '../../assets/images/contact/Matrix_logo.svg.png'
import gitlabIcon from '../../assets/images/contact/gitlab_icon.png'

const ContactInfo = () => {
    return (
        <div className="contact-info-area pt-100 pb-70">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="contact-info-box">
                            <div className="back-icon">
                                <i className='bx bx-map'></i>
                            </div>
                            <div className="icon">
                                <i className='bx bx-map'></i>
                            </div>
                            <h3>Our Address</h3>
                            <p>Cover-Rest GbR, Am Inselpark 9, 21109 Hamburg, Germany</p>
                        </div>
                    </div>

                    {/* <div className="col-lg-4 col-md-6">
                        <div className="contact-info-box">
                            <div className="back-icon">
                                <i className='bx bx-phone-call'></i>
                            </div>
                            <div className="icon">
                                <i className='bx bx-phone-call'></i>
                            </div>
                            <h3>Contact</h3>
                            <p>Mobile: <a href="tel:+44457895789">(+44) - 45789 - 5789</a></p>
                            <p>E-mail: <a href="mailto:hello@rewy.com">hello@rewy.com</a></p>
                        </div>
                    </div> */}

                    <div className="col-lg-4 col-md-6">
                        <div className="contact-info-box">
                            <div className="icon">
                                <img src={matrixIcon} alt="banner" />
                            </div>
                            <h3>Matrix Chat</h3>
                            <p>Cover-Rest public matrix chat</p>
                            <Link to="https://matrix.to/#/#cover-rest-project:matrix.org" className="default-btn">
                                        <i className="flaticon-right"></i> 
                                        Join Channel <span></span>
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="contact-info-box">
                            <div className="icon">
                                <img src={gitlabIcon} alt="banner" />
                            </div>
                            <h3>Gitlab Project</h3>
                            <p>Cover-Rest Gitlab Porject</p>
                            <Link to="https://gitlab.com/cover-rest/cover-rest" className="default-btn">
                                        <i className="flaticon-right"></i> 
                                        Visit <span></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactInfo
